<template>
  <table-view ref="table" class="h-full"
    :get-params-detalle="getParamsDetalleAux"
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :disable-routes="disableRoutes"
    :normalize-data="normalizeData"
    :filter-panel="FilterPanel"
    :header-url="headerUrl"
    :excel-name="excelName"
    :id-vista="idVista"
    :header-title="headerTitle"
    :header-icon="headerIcon"
    :vuexnamespace="vuexnamespace"
    :payload-single-id="PayloadSingleId"
    :breadcrumbs="breadcrumbs"
    :lista-acciones="listaAcciones"
    :footer-acciones="footerAcciones"
    @executeAction="executeAction"
  >
    <template slot="dialogs">
      <user-link-groups-dialog 
        :dialogOpen="linkGroupToUserDialog" 
        :userId="this.$route.params.id" 
        @toggleDialog="toggleDialogs" 
        @applyDialog="applyLinkHandler" 
      />
      <user-link-users-dialog
        :dialogOpen="addTemporalDialog"
        :idUsuario="$route.params.id"
        @toggleDialog="toggleAddTemporal"
        @applyDialog="applyAddTemporal"
        :labelOrigen="$t('groups.origen_groups')"
        :labelDestino="$t('groups.destino_groups')"
        :title="$t('configurations.add_temporal_groups')"
      />
    </template>
  </table-view>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'
import TableView from '@/components/interfaces/TableView.vue'
import CustomFilter from '@/components/filters/GroupsFilterByUser.vue'
import UserLinkGroupsDialog from '@/components/UserLinkGroupsDialog.vue'
import UserLinkUsersDialog from '@/components/UserLinkUsersDialog.vue'

import { gGetUserGruposPag } from '@/services/configurations/groups/gGetUserGruposPag'
import { gGetUserGruposExcel } from '@/services/configurations/groups/gGetUserGruposExcel'

import { getUser } from '@/services/configurations/getUser'

import { linkUserToGroups } from '@/services/configurations/groups/linkUserToGroups'
import { unlinkUserGroups } from '@/services/configurations/groups/unlinkUserGroups'
import { removeTemporalesGroups } from '@/services/configurations/groups/removeTemporalesGroups'
import { addTraspasoGroups } from '@/services/configurations/groups/addTraspasoGroups'

export default {
  name: 'groups-by-user-list-view',
  components: {
    TableView,
    UserLinkGroupsDialog,
    UserLinkUsersDialog
  },
  data () {
    return {
      idVista: 52,
      FilterPanel: CustomFilter,
      vuexnamespace: 'usergroups',
      headerTitle: i18n.t('groups.groups_link'),
      headerIcon: 'config',
      headerUrl: 'configurations/users/details',
      excelName: `${i18n.t('users.entity_name').toLowerCase()}-${i18n.t('groups.header').toLowerCase()}.xlsx`,
      breadcrumbName: 'Nombre',
      breadcrumbs: [],
      PayloadSingleId: 'IdGrupo',
      listaAcciones: [
        { IdAccion: 1, Descripcion: i18n.t('app.unlink_entity'), icon: 'unlink' }
      ],
      footerAcciones: [
        { text: i18n.t('configurations.delete_temporal'), icon: 'unlink', handler: this.deleteTemporal },
        { text: i18n.t('configurations.add_temporal_groups'), icon: 'link', handler: this.toggleAddTemporal },
        { text: i18n.t('groups.link_groups'), icon: 'plus', handler: this.golinkTagToUser }
      ],

      showModal: false,
      linkGroupToUserDialog: false,
      addTemporalDialog: false,
    }
  },
  mounted () {
    this.breadcrumbs = [
      {
        url: this.role === 3 ? 'configurationssa' : 'configurations', 
        name: i18n.t('configurations.header') 
      },
      { url: 'configurations/users', name: i18n.t('users.header') },
      { paths: ['Usuario'] },
    ]
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposGrupo: function () {
      return this.$store.getters['config/TIPOS_GRUPO']
    }
  },
  methods: {
    getParamsDetalleAux () {
      return { idUsuario: this.$route.params.id }
    },
    getParamsAux (data) {
      return {
        idUsuario: this.$route.params.id,
        temporal: data.temporal ? data.temporal.value : null,
        nombre: data.name ? data.name.value : null,
        tipo: data.tipoGrupo ? data.tipoGrupo.value : null,
        VerTodoGrupos: data.verTodoGroups ? data.verTodoGroups.value : null,
        VerTodoEstados: data.verTodoStatuses ? data.verTodoStatuses.value : null,
        VerTodoEmpresas: data.verTodoCompanies ? data.verTodoCompanies.value : null,
        email: data.email ? data.email.value : null,
        numeroSMSGenerico: data.phone ? data.phone.value : null,
        enviarAvisos: data.send_alerts ? data.send_alerts.value : null,
        enviarAvisosUsuarios: data.enviarAvisosUsuarios ? data.enviarAvisosUsuarios.value : null,
      }
    },
    getDetalleAux: async function (objOrder, params) {
      return await getUser(objOrder, params)
    },
    getPagAux: async function (objOrder, params) {
      return await gGetUserGruposPag(objOrder, params)
    },
    getExcelAux: async function (objOrder, params) {
      return await gGetUserGruposExcel(objOrder, params)
    },
    normalizeData: function (data = []) {
      return data.map(item => {
        item.Tipo = this.tiposGrupo.find(x => x.temp === item.idTipo)?.name ?? item.Tipo
        return item
      })
    },
    executeAction: async function (action, selected = []) {
      if (selected.length) {
        if (action.IdAccion === 1) {
          this.unlink()
        } else {
          console.error(i18n.t('feedback.error.unexpected_action_error', { action: JSON.stringify(action) }))
        }
      }
    },
    disableRoutes: function (user) {
      const isDisabledByRol = (user.idRol === 7 || user.idRol === 8 || user.idRol === 3)
      const isDisabledByProvider = user.idRol === 9
      const objDisableRoutes = {
        disableGroups: isDisabledByRol || isDisabledByProvider,
        disableStatuses: user.VerTodoEstados || isDisabledByRol || isDisabledByProvider,
        disableCompanies: user.VerTodoEmpresas || isDisabledByRol || isDisabledByProvider,
        disableProviderCompanies: !isDisabledByProvider
      }
      bus.$emit('disableOptionsUser', objDisableRoutes)
    },
    unlink: async function (selected) {
      await this.unlinkHandler(selected)
      // for await (const element of selected) {
      //   await this.unlinkHandler(element.IdTag)
      // }
      this.data = await this.$refs.table.applyFilters()
    },
    unlinkHandler: async function (grupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = this.$route.params.id
        const payload = { idUsuario: idUsuario, idGrupos: [] }
        grupos.forEach(element => {
          payload.idGrupos.push(element.IdGrupo)
        })
        const response = await unlinkUserGroups(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_unlinked_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleAddTemporal () {
      this.addTemporalDialog = !this.addTemporalDialog
    },
    applyAddTemporal: async function ({ users, radioOrigen, radioDestino }) {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = this.$route.params.id
        const payload = {
          idUsuario: idUsuario,
          idUsuarios: users,
          TemporalOrigen: radioOrigen,
          TemporalDestino: radioDestino,
        }
        const response = await addTraspasoGroups(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.$refs.table.applyFilters()
          this.doFeedback(i18n.t('feedback.success.transfered_groups_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.toggleAddTemporal()
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteTemporal: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = this.$route.params.id
        const response = await removeTemporalesGroups({ idUsuario: idUsuario })
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.$refs.table.applyFilters()
          this.doFeedback(i18n.t('feedback.success.temporal_removed_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDialogs: function () {
      this.linkGroupToUserDialog = !this.linkGroupToUserDialog
    },
    golinkTagToUser: function () {
      this.linkGroupToUserDialog = !this.linkGroupToUserDialog
    },
    applyLinkHandler: async function (tags) {
      this.linkTagToUser = false
      await this.linkHandler(tags)
      this.$refs.table.applyFilters()
    },
    linkHandler: async function (idGrupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const idUsuario = this.$route.params.id
        const payload = { idUsuario: idUsuario, idGrupos: idGrupos }
        const response = await linkUserToGroups(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
          this.toggleDialogs()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
  },
}
</script>

<style scoped>

</style>
